import Loadable from "react-loadable";
import PageSpinner from "../../components/common/PageSpinner";

export default Loadable({
    loader: () => import("./OrdersPage"),
    delay: 200,
    loading: PageSpinner
});
